import { withShowIf } from '../../../../helpers/with-show-if/with-show-if.component'
import { ErrorMessageProps } from './error-message.props'
import { ErrorMessageStyles } from './error-message.styles'

export const ErrorMessage = withShowIf((props: ErrorMessageProps) => {
  return <span className={ErrorMessageStyles.error}>{props.errorMessage}</span>
})
